import React from 'react';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Announcement from 'buyside/components/presentation/Feed/Announcement/announcement';
import FeedItems from 'buyside/components/presentation/Feed/FeedItems/feedItems';

import { onboardingUrl } from 'buyside/util/urlHelper';

const SampleFeedItemsPanel = ({ loading, sampleFeedItems, currentUser }) => {
  const recordOnboardingClick = () => {
    if (window.hj) {
      window.hj('tagRecording', ['activity_feed_onboarding_click']);
    }
  };

  if (loading) return <LoadingSpinner type="secondary" size="large" />;

  return (
    <div>
      <Announcement title={'This Section Is Locked: Unlock Now'} options={{}}>
        Your Activity Feed is currently inactive. In order to unlock it, please click the link below
        and set your preferences. Doing so takes 2-3 minutes and will generate a personalized filter
        of site research/data that is generated based on your unique preferences.
        <div style={{ textAlign: 'center', marginTop: '15px' }}>
          <Button
            onClick={recordOnboardingClick}
            type={BUTTON_TYPES.PRIMARY}
            url={onboardingUrl()}
            text="Activate Your Feed"
          />
        </div>
      </Announcement>

      <FeedItems feedItems={sampleFeedItems} currentUser={currentUser} />
    </div>
  );
};

export default SampleFeedItemsPanel;
